/* eslint-disable import/no-default-export */
export default () => [
  {
    countryCode: 'AU',
    name: 'Australia',
  },
  {
    countryCode: 'GB',
    name: 'United Kingdom',
  },
  {
    countryCode: 'HK',
    name: 'Hong Kong',
  },
  {
    countryCode: 'ID',
    name: 'Indonesia',
  },
  {
    countryCode: 'MY',
    name: 'Malaysia',
  },
  {
    countryCode: 'NZ',
    name: 'New Zealand',
  },
  {
    countryCode: 'PH',
    name: 'Philippines',
  },
  {
    countryCode: 'SG',
    name: 'Singapore',
  },
  {
    countryCode: 'TH',
    name: 'Thailand',
  },
];
